import React, { useState } from 'react'
import { useRetorikStore } from '../Contexts/RetorikContext'
import { useViewStore } from '../Contexts/ViewContext'
import { useUtilsStore } from '../Contexts/UtilsContext'
import Remote from './Large/Remote'
import MobileContainer from './Mobile/MobileContainer'
import Dashboard from './Large/Dashboard'
import MicrophoneAndSwitch from './Large/MicrophoneAndSwitch'
import OldDashboard from './Common/OldDashboard'

interface MenuDisplayerProps {
  hideMenu?: boolean
}

const MenuDisplayer = ({ hideMenu }: MenuDisplayerProps): JSX.Element => {
  const menu = useRetorikStore((state) => state.configuration.menu)
  const isMobile = useViewStore((state) => state.isMobile)
  const isBorne = useViewStore((state) => state.isBorne)
  const displayControls = useViewStore((state) => state.displayControls)
  const dashboardOpened = useUtilsStore((state) => state.dashboardOpened)
  const toggleDashboard = useUtilsStore((state) => state.actions.toggleDashboard)
  const [topOfRemote, setTopOfRemote] = useState<number | string>()

  return !displayControls ? (
    <React.Fragment />
  ) : isMobile ? (
    <MobileContainer hideMenu={!!hideMenu} />
  ) : (
    <React.Fragment>
      {isBorne && <MicrophoneAndSwitch top={topOfRemote} />}
      <Remote hideMenu={!!hideMenu} setTopOfRemote={setTopOfRemote} />
      {dashboardOpened && (menu?.categories?.length ? <Dashboard toggleDashboard={(): void => toggleDashboard(true)} /> : <OldDashboard toggleDashboard={(): void => toggleDashboard(true)} />)}
    </React.Fragment>
  )
}

export default MenuDisplayer
